(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~select~treeSelect"],{

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "AbstractSelectProps", function() { return /* binding */ select_AbstractSelectProps; });
__webpack_require__.d(__webpack_exports__, "SelectValue", function() { return /* binding */ SelectValue; });
__webpack_require__.d(__webpack_exports__, "SelectProps", function() { return /* binding */ SelectProps; });

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var warning = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./node_modules/component-classes/index.js
var component_classes = __webpack_require__(47);
var component_classes_default = /*#__PURE__*/__webpack_require__.n(component_classes);

// EXTERNAL MODULE: ./src/base/vc-menu/index.js + 10 modules
var vc_menu = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning_warning = __webpack_require__(16);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning_warning);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/base/vc-select/Option.jsx

/* harmony default export */ var Option = ({
  props: {
    value: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    label: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    disabled: vue_types["a" /* default */].bool,
    title: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])
  },
  isSelectOption: true
});
// CONCATENATED MODULE: ./src/base/vc-select/OptGroup.jsx

/* harmony default export */ var OptGroup = ({
  props: {
    value: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    label: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])
  },
  isSelectOptGroup: true
});
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/getTransitionProps.js
var getTransitionProps = __webpack_require__(22);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/proxyComponent.js
var proxyComponent = __webpack_require__(68);

// EXTERNAL MODULE: ./node_modules/vue-ref/index.js
var vue_ref = __webpack_require__(24);
var vue_ref_default = /*#__PURE__*/__webpack_require__.n(vue_ref);

// EXTERNAL MODULE: ./node_modules/raf/index.js
var raf = __webpack_require__(14);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// EXTERNAL MODULE: ./src/base/vc-trigger/index.js + 9 modules
var vc_trigger = __webpack_require__(25);

// EXTERNAL MODULE: ./node_modules/dom-scroll-into-view/dist-web/index.js
var dist_web = __webpack_require__(69);

// CONCATENATED MODULE: ./src/base/vc-select/util.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



function toTitle(title) {
  if (typeof title === 'string') {
    return title.trim();
  }

  return '';
}
function getValuePropValue(child) {
  if (!child) {
    return null;
  }

  var props = Object(props_util["getPropsData"])(child);

  if ('value' in props) {
    return props.value;
  }

  if (Object(props_util["getKey"])(child) !== undefined) {
    return Object(props_util["getKey"])(child);
  }

  if (Object(props_util["getSlotOptions"])(child).isSelectOptGroup) {
    var label = Object(props_util["getComponentFromProp"])(child, 'label');

    if (label) {
      return label;
    }
  }

  throw new Error("Need at least a key or a value or a label (only for OptGroup) for ".concat(child));
}
function getPropValue(child, prop) {
  if (prop === 'value') {
    return getValuePropValue(child);
  }

  if (prop === 'children') {
    var newChild = child.$slots ? Object(vnode["b" /* cloneVNodes */])(child.$slots.default, true) : Object(vnode["b" /* cloneVNodes */])(child.componentOptions.children, true);

    if (newChild.length === 1 && !newChild[0].tag) {
      return newChild[0].text;
    }

    return newChild;
  }

  var data = Object(props_util["getPropsData"])(child);

  if (prop in data) {
    return data[prop];
  } else {
    return Object(props_util["getAttrs"])(child)[prop];
  }
}
function isMultiple(props) {
  return props.multiple;
}
function isCombobox(props) {
  return props.combobox;
}
function isMultipleOrTags(props) {
  return props.multiple || props.tags;
}
function isMultipleOrTagsOrCombobox(props) {
  return isMultipleOrTags(props) || isCombobox(props);
}
function isSingleMode(props) {
  return !isMultipleOrTagsOrCombobox(props);
}
function toArray(value) {
  var ret = value;

  if (value === undefined) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  }

  return ret;
}
function getMapKey(value) {
  return "".concat(_typeof(value), "-").concat(value);
}
function preventDefaultEvent(e) {
  e.preventDefault();
}
function findIndexInValueBySingleValue(value, singleValue) {
  var index = -1;

  if (value) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === singleValue) {
        index = i;
        break;
      }
    }
  }

  return index;
}
function getLabelFromPropsValue(value, key) {
  var label;
  value = toArray(value);

  if (value) {
    for (var i = 0; i < value.length; i++) {
      if (value[i].key === key) {
        label = value[i].label;
        break;
      }
    }
  }

  return label;
}
function getSelectKeys(menuItems, value) {
  if (value === null || value === undefined) {
    return [];
  }

  var selectedKeys = [];
  menuItems.forEach(function (item) {
    if (Object(props_util["getSlotOptions"])(item).isMenuItemGroup) {
      selectedKeys = selectedKeys.concat(getSelectKeys(item.componentOptions.children, value));
    } else {
      var itemValue = getValuePropValue(item);
      var itemKey = item.key;

      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey !== undefined) {
        selectedKeys.push(itemKey);
      }
    }
  });
  return selectedKeys;
}
var UNSELECTABLE_STYLE = {
  userSelect: 'none',
  WebkitUserSelect: 'none'
};
var UNSELECTABLE_ATTRIBUTE = {
  unselectable: 'on'
};
function findFirstMenuItem(children) {
  for (var i = 0; i < children.length; i++) {
    var child = children[i];
    var props = Object(props_util["getPropsData"])(child);

    if (Object(props_util["getSlotOptions"])(child).isMenuItemGroup) {
      var found = findFirstMenuItem(child.componentOptions.children);

      if (found) {
        return found;
      }
    } else if (!props.disabled) {
      return child;
    }
  }

  return null;
}
function includesSeparators(str, separators) {
  for (var i = 0; i < separators.length; ++i) {
    if (str.lastIndexOf(separators[i]) > 0) {
      return true;
    }
  }

  return false;
}
function splitBySeparators(str, separators) {
  var reg = new RegExp("[".concat(separators.join(), "]"));
  return str.split(reg).filter(function (token) {
    return token;
  });
}
function defaultFilterFn(input, child) {
  var props = Object(props_util["getPropsData"])(child);

  if (props.disabled) {
    return false;
  }

  var value = getPropValue(child, this.optionFilterProp);

  if (value.length && value[0].text) {
    value = value[0].text;
  } else {
    value = String(value);
  }

  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
}
function validateOptionValue(value, props) {
  if (isSingleMode(props) || isMultiple(props)) {
    return;
  }

  if (typeof value !== 'string') {
    throw new Error("Invalid `value` of type `".concat(_typeof(value), "` supplied to Option, ") + "expected `string` when `tags/combobox` is `true`.");
  }
}
function saveRef(instance, name) {
  return function (node) {
    instance[name] = node;
  };
}
function generateUUID() {
  if (false) {}

  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}
// CONCATENATED MODULE: ./src/base/vc-select/DropdownMenu.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* harmony default export */ var DropdownMenu = ({
  name: 'DropdownMenu',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    ariaId: vue_types["a" /* default */].string,
    defaultActiveFirstOption: vue_types["a" /* default */].bool,
    value: vue_types["a" /* default */].any,
    dropdownMenuStyle: vue_types["a" /* default */].object,
    multiple: vue_types["a" /* default */].bool,
    // onPopupFocus: PropTypes.func,
    // onPopupScroll: PropTypes.func,
    // onMenuDeSelect: PropTypes.func,
    // onMenuSelect: PropTypes.func,
    prefixCls: vue_types["a" /* default */].string,
    menuItems: vue_types["a" /* default */].any,
    inputValue: vue_types["a" /* default */].string,
    visible: vue_types["a" /* default */].bool,
    backfillValue: vue_types["a" /* default */].any,
    firstActiveValue: vue_types["a" /* default */].string,
    menuItemSelectedIcon: vue_types["a" /* default */].any
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (!val) {
        this.lastVisible = val;
      } else {
        this.$nextTick(function () {
          _this.scrollActiveItemToView();
        });
      }
    }
  },
  created: function created() {
    this.rafInstance = null;
    this.lastInputValue = this.$props.inputValue;
    this.lastVisible = false;
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.scrollActiveItemToView();
    });
    this.lastVisible = this.$props.visible;
  },
  updated: function updated() {
    var props = this.$props; // if (!this.prevVisible && props.visible) {
    //   this.$nextTick(() => {
    //     this.scrollActiveItemToView();
    //   });
    // }

    this.lastVisible = props.visible;
    this.lastInputValue = props.inputValue;
    this.prevVisible = this.visible;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.rafInstance) {
      raf_default.a.cancel(this.rafInstance);
    }
  },
  methods: {
    scrollActiveItemToView: function scrollActiveItemToView() {
      var _this3 = this;

      // scroll into view
      var itemComponent = this.firstActiveItem && this.firstActiveItem.$el;
      var props = this.$props;
      var value = props.value,
          visible = props.visible,
          firstActiveValue = props.firstActiveValue;

      if (!itemComponent || !visible) {
        return;
      }

      var scrollIntoViewOpts = {
        onlyScrollIfNeeded: true
      };

      if ((!value || value.length === 0) && firstActiveValue) {
        scrollIntoViewOpts.alignWithTop = true;
      } // Delay to scroll since current frame item position is not ready when pre view is by filter
      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462


      this.rafInstance = raf_default()(function () {
        Object(dist_web["a" /* default */])(itemComponent, _this3.$refs.menuRef.$el, scrollIntoViewOpts);
      });
    },
    renderMenu: function renderMenu() {
      var _this4 = this;

      var h = this.$createElement;
      var props = this.$props;
      var menuItems = props.menuItems,
          defaultActiveFirstOption = props.defaultActiveFirstOption,
          value = props.value,
          prefixCls = props.prefixCls,
          multiple = props.multiple,
          inputValue = props.inputValue,
          firstActiveValue = props.firstActiveValue,
          dropdownMenuStyle = props.dropdownMenuStyle,
          backfillValue = props.backfillValue,
          visible = props.visible;
      var menuItemSelectedIcon = Object(props_util["getComponentFromProp"])(this, 'menuItemSelectedIcon');

      var _getListeners = Object(props_util["getListeners"])(this),
          menuDeselect = _getListeners.menuDeselect,
          menuSelect = _getListeners.menuSelect,
          popupScroll = _getListeners.popupScroll;

      if (menuItems && menuItems.length) {
        var selectedKeys = getSelectKeys(menuItems, value);
        var menuProps = {
          props: {
            multiple: multiple,
            itemIcon: multiple ? menuItemSelectedIcon : null,
            selectedKeys: selectedKeys,
            prefixCls: "".concat(prefixCls, "-menu")
          },
          on: {},
          style: dropdownMenuStyle,
          ref: 'menuRef',
          attrs: {
            role: 'listbox'
          }
        };

        if (popupScroll) {
          menuProps.on.scroll = popupScroll;
        }

        if (multiple) {
          menuProps.on.deselect = menuDeselect;
          menuProps.on.select = menuSelect;
        } else {
          menuProps.on.click = menuSelect;
        }

        var activeKeyProps = {};
        var defaultActiveFirst = defaultActiveFirstOption;
        var clonedMenuItems = menuItems;

        if (selectedKeys.length || firstActiveValue) {
          if (props.visible && !this.lastVisible) {
            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
          } else if (!visible) {
            // Do not trigger auto active since we already have selectedKeys
            if (selectedKeys[0]) {
              defaultActiveFirst = false;
            }

            activeKeyProps.activeKey = undefined;
          }

          var foundFirst = false; // set firstActiveItem via cloning menus
          // for scroll into view

          var clone = function clone(item) {
            if (!foundFirst && selectedKeys.indexOf(item.key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
              foundFirst = true;
              return Object(vnode["a" /* cloneElement */])(item, {
                directives: [{
                  name: 'meg-ref',
                  value: function value(ref) {
                    _this4.firstActiveItem = ref;
                  }
                }]
              });
            }

            return item;
          };

          clonedMenuItems = menuItems.map(function (item) {
            if (Object(props_util["getSlotOptions"])(item).isMenuItemGroup) {
              var children = item.componentOptions.children.map(clone);
              return Object(vnode["a" /* cloneElement */])(item, {
                children: children
              });
            }

            return clone(item);
          });
        } else {
          // Clear firstActiveItem when dropdown menu items was empty
          // Avoid `Unable to find node on an unmounted component`
          // https://github.com/ant-design/ant-design/issues/10774
          this.firstActiveItem = null;
        } // clear activeKey when inputValue change


        var lastValue = value && value[value.length - 1];

        if (inputValue !== this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
          activeKeyProps.activeKey = '';
        }

        menuProps.props = _objectSpread(_objectSpread(_objectSpread({}, activeKeyProps), menuProps.props), {}, {
          defaultActiveFirst: defaultActiveFirst
        });
        return h(vc_menu["e" /* default */], menuProps, [clonedMenuItems]);
      }

      return null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var renderMenu = this.renderMenu();

    var _getListeners2 = Object(props_util["getListeners"])(this),
        popupFocus = _getListeners2.popupFocus,
        popupScroll = _getListeners2.popupScroll;

    return renderMenu ? h("div", {
      style: {
        overflow: 'auto',
        transform: 'translateZ(0)'
      },
      attrs: {
        id: this.$props.ariaId,
        tabIndex: "-1"
      },
      on: {
        "focus": popupFocus,
        "mousedown": preventDefaultEvent,
        "scroll": popupScroll
      },
      ref: "menuContainer"
    }, [renderMenu]) : null;
  }
});
// CONCATENATED MODULE: ./src/base/vc-select/SelectTrigger.jsx
function SelectTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SelectTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SelectTrigger_ownKeys(Object(source), true).forEach(function (key) { SelectTrigger_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SelectTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SelectTrigger_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
/* harmony default export */ var SelectTrigger = ({
  name: 'SelectTrigger',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    // onPopupFocus: PropTypes.func,
    // onPopupScroll: PropTypes.func,
    dropdownMatchSelectWidth: vue_types["a" /* default */].bool,
    defaultActiveFirstOption: vue_types["a" /* default */].bool,
    dropdownAlign: vue_types["a" /* default */].object,
    visible: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    showSearch: vue_types["a" /* default */].bool,
    dropdownClassName: vue_types["a" /* default */].string,
    dropdownStyle: vue_types["a" /* default */].object,
    dropdownMenuStyle: vue_types["a" /* default */].object,
    multiple: vue_types["a" /* default */].bool,
    inputValue: vue_types["a" /* default */].string,
    filterOption: vue_types["a" /* default */].any,
    empty: vue_types["a" /* default */].bool,
    options: vue_types["a" /* default */].any,
    prefixCls: vue_types["a" /* default */].string,
    popupClassName: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].array,
    // children: PropTypes.any,
    showAction: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string),
    combobox: vue_types["a" /* default */].bool,
    animation: vue_types["a" /* default */].string,
    transitionName: vue_types["a" /* default */].string,
    getPopupContainer: vue_types["a" /* default */].func,
    backfillValue: vue_types["a" /* default */].any,
    menuItemSelectedIcon: vue_types["a" /* default */].any,
    dropdownRender: vue_types["a" /* default */].func,
    ariaId: vue_types["a" /* default */].string,
    dark: vue_types["a" /* default */].bool
  },
  data: function data() {
    return {
      dropdownWidth: 0
    };
  },
  created: function created() {
    this.rafInstance = null;
    this.saveDropdownMenuRef = saveRef(this, 'dropdownMenuRef');
    this.saveTriggerRef = saveRef(this, 'triggerRef');
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.setDropdownWidth();
    });
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.setDropdownWidth();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelRafInstance();
  },
  methods: {
    setDropdownWidth: function setDropdownWidth() {
      var _this3 = this;

      this.cancelRafInstance();
      this.rafInstance = raf_default()(function () {
        var width = _this3.$el.offsetWidth;

        if (width !== _this3.dropdownWidth) {
          _this3.setState({
            dropdownWidth: width
          });
        }
      });
    },
    cancelRafInstance: function cancelRafInstance() {
      if (this.rafInstance) {
        raf_default.a.cancel(this.rafInstance);
      }
    },
    getInnerMenu: function getInnerMenu() {
      return this.dropdownMenuRef && this.dropdownMenuRef.$refs.menuRef;
    },
    getPopupDOMNode: function getPopupDOMNode() {
      return this.triggerRef.getPopupDomNode();
    },
    getDropdownElement: function getDropdownElement(newProps) {
      var h = this.$createElement;
      var value = this.value,
          firstActiveValue = this.firstActiveValue,
          defaultActiveFirstOption = this.defaultActiveFirstOption,
          dropdownMenuStyle = this.dropdownMenuStyle,
          getDropdownPrefixCls = this.getDropdownPrefixCls,
          backfillValue = this.backfillValue,
          menuItemSelectedIcon = this.menuItemSelectedIcon;

      var _getListeners = Object(props_util["getListeners"])(this),
          menuSelect = _getListeners.menuSelect,
          menuDeselect = _getListeners.menuDeselect,
          popupScroll = _getListeners.popupScroll;

      var props = this.$props;
      var dropdownRender = props.dropdownRender,
          ariaId = props.ariaId;
      var dropdownMenuProps = {
        props: SelectTrigger_objectSpread(SelectTrigger_objectSpread({}, newProps.props), {}, {
          ariaId: ariaId,
          prefixCls: getDropdownPrefixCls(),
          value: value,
          firstActiveValue: firstActiveValue,
          defaultActiveFirstOption: defaultActiveFirstOption,
          dropdownMenuStyle: dropdownMenuStyle,
          backfillValue: backfillValue,
          menuItemSelectedIcon: menuItemSelectedIcon
        }),
        on: SelectTrigger_objectSpread(SelectTrigger_objectSpread({}, newProps.on), {}, {
          menuSelect: menuSelect,
          menuDeselect: menuDeselect,
          popupScroll: popupScroll
        }),
        directives: [{
          name: 'meg-ref',
          value: this.saveDropdownMenuRef
        }]
      };
      var menuNode = h(DropdownMenu, dropdownMenuProps);

      if (dropdownRender) {
        return dropdownRender(menuNode, props);
      }

      return null;
    },
    getDropdownTransitionName: function getDropdownTransitionName() {
      var props = this.$props;
      var transitionName = props.transitionName;

      if (!transitionName && props.animation) {
        transitionName = "".concat(this.getDropdownPrefixCls(), "-").concat(props.animation);
      }

      return transitionName;
    },
    getDropdownPrefixCls: function getDropdownPrefixCls() {
      return "".concat(this.prefixCls, "-dropdown");
    }
  },
  render: function render() {
    var _popupClassName;

    var h = arguments[0];
    var $props = this.$props,
        $slots = this.$slots;
    var multiple = $props.multiple,
        visible = $props.visible,
        inputValue = $props.inputValue,
        dropdownAlign = $props.dropdownAlign,
        disabled = $props.disabled,
        showSearch = $props.showSearch,
        dropdownClassName = $props.dropdownClassName,
        dropdownStyle = $props.dropdownStyle,
        dropdownMatchSelectWidth = $props.dropdownMatchSelectWidth,
        options = $props.options,
        getPopupContainer = $props.getPopupContainer,
        showAction = $props.showAction,
        empty = $props.empty,
        dark = $props.dark;

    var _getListeners2 = Object(props_util["getListeners"])(this),
        mouseenter = _getListeners2.mouseenter,
        mouseleave = _getListeners2.mouseleave,
        popupFocus = _getListeners2.popupFocus,
        dropdownVisibleChange = _getListeners2.dropdownVisibleChange;

    var dropdownPrefixCls = this.getDropdownPrefixCls();
    var popupClassName = (_popupClassName = {}, SelectTrigger_defineProperty(_popupClassName, dropdownClassName, !!dropdownClassName), SelectTrigger_defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--").concat(multiple ? 'multiple' : 'single'), 1), SelectTrigger_defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--empty"), empty), SelectTrigger_defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--dark"), dark), _popupClassName);
    var popupElement = this.getDropdownElement({
      props: {
        menuItems: options,
        multiple: multiple,
        inputValue: inputValue,
        visible: visible
      },
      on: {
        popupFocus: popupFocus
      }
    });
    var hideAction;

    if (disabled) {
      hideAction = [];
    } else if (isSingleMode($props) && !showSearch) {
      hideAction = ['click'];
    } else {
      hideAction = ['blur'];
    }

    var popupStyle = SelectTrigger_objectSpread({}, dropdownStyle);

    var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';

    if (this.dropdownWidth) {
      popupStyle[widthProp] = "".concat(this.dropdownWidth, "px");
    }

    var triggerProps = {
      props: SelectTrigger_objectSpread(SelectTrigger_objectSpread({}, $props), {}, {
        showAction: disabled ? [] : showAction,
        hideAction: hideAction,
        ref: 'triggerRef',
        popupPlacement: 'bottomLeft',
        builtinPlacements: BUILT_IN_PLACEMENTS,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: this.getDropdownTransitionName(),
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: external_classnames_default()(popupClassName),
        popupStyle: popupStyle
      }),
      on: {
        popupVisibleChange: dropdownVisibleChange
      },
      directives: [{
        name: 'meg-ref',
        value: this.saveTriggerRef
      }]
    };

    if (mouseenter) {
      triggerProps.on.mouseenter = mouseenter;
    }

    if (mouseleave) {
      triggerProps.on.mouseleave = mouseleave;
    }

    return h(vc_trigger["a" /* default */], triggerProps, [$slots.default, h("template", {
      slot: "popup"
    }, [popupElement])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-select/PropTypes.js

var SelectPropTypes = {
  defaultActiveFirstOption: vue_types["a" /* default */].bool,
  multiple: vue_types["a" /* default */].bool,
  filterOption: vue_types["a" /* default */].any,
  // children: PropTypes.any,
  showSearch: vue_types["a" /* default */].bool,
  disabled: vue_types["a" /* default */].bool,
  allowClear: vue_types["a" /* default */].bool,
  showArrow: vue_types["a" /* default */].bool,
  tags: vue_types["a" /* default */].bool,
  prefixCls: vue_types["a" /* default */].string,
  // className: PropTypes.string,
  transitionName: vue_types["a" /* default */].string,
  optionLabelProp: vue_types["a" /* default */].string,
  optionFilterProp: vue_types["a" /* default */].string,
  animation: vue_types["a" /* default */].string,
  choiceTransitionName: vue_types["a" /* default */].string,
  open: vue_types["a" /* default */].bool,
  defaultOpen: vue_types["a" /* default */].bool,
  // onChange: PropTypes.func,
  // onBlur: PropTypes.func,
  // onFocus: PropTypes.func,
  // onSelect: PropTypes.func,
  // onSearch: PropTypes.func,
  // onPopupScroll: PropTypes.func,
  // onMouseEnter: PropTypes.func,
  // onMouseLeave: PropTypes.func,
  // onInputKeyDown: PropTypes.func,
  placeholder: vue_types["a" /* default */].any,
  // onDeselect: PropTypes.func,
  labelInValue: vue_types["a" /* default */].bool,
  loading: vue_types["a" /* default */].bool,
  value: vue_types["a" /* default */].any,
  defaultValue: vue_types["a" /* default */].any,
  dropdownStyle: vue_types["a" /* default */].object,
  dropdownClassName: vue_types["a" /* default */].string,
  maxTagTextLength: vue_types["a" /* default */].number,
  maxTagCount: vue_types["a" /* default */].number,
  maxTagPlaceholder: vue_types["a" /* default */].any,
  tokenSeparators: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string),
  getInputElement: vue_types["a" /* default */].func,
  showAction: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string),
  autoFocus: vue_types["a" /* default */].bool,
  getPopupContainer: vue_types["a" /* default */].func,
  clearIcon: vue_types["a" /* default */].any,
  inputIcon: vue_types["a" /* default */].any,
  removeIcon: vue_types["a" /* default */].any,
  menuItemSelectedIcon: vue_types["a" /* default */].any,
  dropdownRender: vue_types["a" /* default */].func,
  mode: vue_types["a" /* default */].oneOf(['multiple', 'tags']),
  backfill: vue_types["a" /* default */].bool,
  dropdownAlign: vue_types["a" /* default */].any,
  dropdownMatchSelectWidth: vue_types["a" /* default */].bool,
  dropdownMenuStyle: vue_types["a" /* default */].object,
  notFoundContent: vue_types["a" /* default */].oneOfType([String, Number]),
  tabIndex: vue_types["a" /* default */].oneOfType([String, Number])
};
// EXTERNAL MODULE: ./src/base/vc-util/Dom/contains.js
var contains = __webpack_require__(35);

// CONCATENATED MODULE: ./src/utils/env.js
/* eslint-disable no-undef */
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// EXTERNAL MODULE: ./src/base/vc-select/assets/index.scss
var assets = __webpack_require__(339);

// CONCATENATED MODULE: ./src/base/vc-select/Select.jsx












function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Select_ownKeys(Object(source), true).forEach(function (key) { Select_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Select_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















 // style


external_vue_default.a.use(vue_ref_default.a, {
  name: 'meg-ref'
});
var SELECT_EMPTY_VALUE_KEY = 'RC_SELECT_EMPTY_VALUE_KEY';

var noop = function noop() {
  return null;
}; // Where el is the DOM element you'd like to test for visibility


function isHidden(node) {
  return !node || node.offsetParent === null;
}

function chaining() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // eslint-disable-line
    // eslint-disable-line
    for (var i = 0; i < fns.length; i++) {
      if (fns[i] && typeof fns[i] === 'function') {
        fns[i].apply(chaining, args);
      }
    }
  };
}

var Select = {
  inheritAttrs: false,
  Option: Option,
  OptGroup: OptGroup,
  name: 'Select',
  mixins: [BaseMixin["a" /* default */]],
  props: Select_objectSpread(Select_objectSpread({}, SelectPropTypes), {}, {
    prefixCls: SelectPropTypes.prefixCls.def('rc-select'),
    defaultOpen: vue_types["a" /* default */].bool.def(false),
    labelInValue: SelectPropTypes.labelInValue.def(false),
    defaultActiveFirstOption: SelectPropTypes.defaultActiveFirstOption.def(true),
    showSearch: SelectPropTypes.showSearch.def(true),
    allowClear: SelectPropTypes.allowClear.def(false),
    placeholder: SelectPropTypes.placeholder.def(''),
    showArrow: SelectPropTypes.showArrow.def(true),
    dropdownMatchSelectWidth: vue_types["a" /* default */].bool.def(true),
    dropdownStyle: SelectPropTypes.dropdownStyle.def(function () {
      return {};
    }),
    dropdownMenuStyle: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    optionFilterProp: SelectPropTypes.optionFilterProp.def('value'),
    optionLabelProp: SelectPropTypes.optionLabelProp.def('value'),
    notFoundContent: vue_types["a" /* default */].any.def('Not Found'),
    backfill: vue_types["a" /* default */].bool.def(false),
    showAction: SelectPropTypes.showAction.def(['click']),
    combobox: vue_types["a" /* default */].bool.def(false),
    tokenSeparators: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string).def([]),
    autoClearSearchValue: vue_types["a" /* default */].bool.def(true),
    tabIndex: vue_types["a" /* default */].any.def(0),
    dropdownRender: vue_types["a" /* default */].func.def(function (menu) {
      return menu;
    }),
    dark: vue_types["a" /* default */].bool // onChange: noop,
    // onFocus: noop,
    // onBlur: noop,
    // onSelect: noop,
    // onSearch: noop,
    // onDeselect: noop,
    // onInputKeydown: noop,

  }),
  model: {
    prop: 'value',
    event: 'change'
  },
  created: function created() {
    this.saveInputRef = saveRef(this, 'inputRef');
    this.saveInputMirrorRef = saveRef(this, 'inputMirrorRef');
    this.saveTopCtrlRef = saveRef(this, 'topCtrlRef');
    this.saveSelectTriggerRef = saveRef(this, 'selectTriggerRef');
    this.saveRootRef = saveRef(this, 'rootRef');
    this.saveSelectionRef = saveRef(this, 'selectionRef');
    this._focused = false;
    this._mouseDown = false;
    this._options = [];
    this._empty = false;
  },
  data: function data() {
    var props = Object(props_util["getOptionProps"])(this);
    var optionsInfo = this.getOptionsInfoFromProps(props);
    warning_default()(this.__propsSymbol__, 'Replace slots.default with props.children and pass props.__propsSymbol__');

    if (props.tags && typeof props.filterOption !== 'function') {
      var isDisabledExist = Object.keys(optionsInfo).some(function (key) {
        return optionsInfo[key].disabled;
      });
      warning_default()(!isDisabledExist, 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    }

    var state = {
      _value: this.getValueFromProps(props, true),
      // true: use default value
      _inputValue: props.combobox ? this.getInputValueForCombobox(props, optionsInfo, true // use default value
      ) : '',
      _open: props.defaultOpen,
      _optionsInfo: optionsInfo,
      _backfillValue: '',
      // a flag for aviod redundant getOptionsInfoFromProps call
      _skipBuildOptionsInfo: true,
      _ariaId: generateUUID()
    };
    return Select_objectSpread(Select_objectSpread({}, state), {}, {
      _mirrorInputValue: state._inputValue
    }, this.getDerivedState(props, state));
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // when defaultOpen is true, we should auto focus search input
      // https://github.com/ant-design/ant-design/issues/14254
      if (_this.autoFocus || _this._open) {
        _this.focus();
      } // this.setState({
      //   _ariaId: generateUUID(),
      // });

    });
  },
  watch: {
    __propsSymbol__: function __propsSymbol__() {
      Object.assign(this.$data, this.getDerivedState(Object(props_util["getOptionProps"])(this), this.$data));
    },
    '$data._inputValue': function $data_inputValue(val) {
      this.$data._mirrorInputValue = val;
    }
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      if (isMultipleOrTags(_this2.$props)) {
        var inputNode = _this2.getInputDOMNode();

        var mirrorNode = _this2.getInputMirrorDOMNode();

        if (inputNode && inputNode.value && mirrorNode) {
          inputNode.style.width = '';
          inputNode.style.width = "".concat(mirrorNode.clientWidth + 10, "px");
        } else if (inputNode) {
          inputNode.style.width = '';
        }
      }

      _this2.forcePopupAlign();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearFocusTime();
    this.clearBlurTime();
    this.clearComboboxTime();

    if (this.dropdownContainer) {
      document.body.removeChild(this.dropdownContainer);
      this.dropdownContainer = null;
    }
  },
  methods: {
    getDerivedState: function getDerivedState(nextProps, prevState) {
      var optionsInfo = prevState._skipBuildOptionsInfo ? prevState._optionsInfo : this.getOptionsInfoFromProps(nextProps, prevState);
      var newState = {
        _optionsInfo: optionsInfo,
        _skipBuildOptionsInfo: false
      };

      if ('open' in nextProps) {
        newState._open = nextProps.open;
      }

      if ('value' in nextProps) {
        var value = this.getValueFromProps(nextProps);
        newState._value = value;

        if (nextProps.combobox) {
          newState._inputValue = this.getInputValueForCombobox(nextProps, optionsInfo);
        }
      }

      return newState;
    },
    getOptionsFromChildren: function getOptionsFromChildren() {
      var _this3 = this;

      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      children.forEach(function (child) {
        if (!child.data || child.data.slot !== undefined) {
          return;
        }

        if (Object(props_util["getSlotOptions"])(child).isSelectOptGroup) {
          _this3.getOptionsFromChildren(child.componentOptions.children, options);
        } else {
          options.push(child);
        }
      });
      return options;
    },
    getInputValueForCombobox: function getInputValueForCombobox(props, optionsInfo, useDefaultValue) {
      var value = [];

      if ('value' in props && !useDefaultValue) {
        value = toArray(props.value);
      }

      if ('defaultValue' in props && useDefaultValue) {
        value = toArray(props.defaultValue);
      }

      if (value.length) {
        value = value[0];
      } else {
        return '';
      }

      var label = value;

      if (props.labelInValue) {
        label = value.label;
      } else if (optionsInfo[getMapKey(value)]) {
        label = optionsInfo[getMapKey(value)].label;
      }

      if (label === undefined) {
        label = '';
      }

      return label;
    },
    getLabelFromOption: function getLabelFromOption(props, option) {
      return getPropValue(option, props.optionLabelProp);
    },
    getOptionsInfoFromProps: function getOptionsInfoFromProps(props, preState) {
      var _this4 = this;

      var options = this.getOptionsFromChildren(this.$props.children);
      var optionsInfo = {};
      options.forEach(function (option) {
        var singleValue = getValuePropValue(option);
        optionsInfo[getMapKey(singleValue)] = {
          option: option,
          value: singleValue,
          label: _this4.getLabelFromOption(props, option),
          title: Object(props_util["getValueByProp"])(option, 'title'),
          disabled: Object(props_util["getValueByProp"])(option, 'disabled')
        };
      });

      if (preState) {
        // keep option info in pre state value.
        var oldOptionsInfo = preState._optionsInfo;
        var value = preState._value;

        if (value) {
          value.forEach(function (v) {
            var key = getMapKey(v);

            if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
              optionsInfo[key] = oldOptionsInfo[key];
            }
          });
        }
      }

      return optionsInfo;
    },
    getValueFromProps: function getValueFromProps(props, useDefaultValue) {
      var value = [];

      if ('value' in props && !useDefaultValue) {
        value = toArray(props.value);
      }

      if ('defaultValue' in props && useDefaultValue) {
        value = toArray(props.defaultValue);
      }

      if (props.labelInValue) {
        value = value.map(function (v) {
          return v.key;
        });
      }

      return value;
    },
    onInputChange: function onInputChange(e) {
      var _e$target = e.target,
          val = _e$target.value,
          composing = _e$target.composing;

      var _this$$data$_inputVal = this.$data._inputValue,
          _inputValue = _this$$data$_inputVal === void 0 ? '' : _this$$data$_inputVal;

      if (e.isComposing || composing || _inputValue === val) {
        this.setState({
          _mirrorInputValue: val
        });
        return;
      }

      var tokenSeparators = this.$props.tokenSeparators;

      if (isMultipleOrTags(this.$props) && tokenSeparators.length && includesSeparators(val, tokenSeparators)) {
        var nextValue = this.getValueByInput(val);

        if (nextValue !== undefined) {
          this.fireChange(nextValue);
        }

        this.setOpenState(false, {
          needFocus: true
        });
        this.setInputValue('', false);
        return;
      }

      this.setInputValue(val);
      this.setState({
        _open: true
      });

      if (isCombobox(this.$props)) {
        this.fireChange([val]);
      }

      this.$emit('input', val);
    },
    onDropdownVisibleChange: function onDropdownVisibleChange(open) {
      if (open && !this._focused) {
        this.clearBlurTime();
        this.timeoutFocus();
        this._focused = true;
        this.updateFocusClassName();
      }

      this.setOpenState(open);
    },
    // combobox ignore
    onKeyDown: function onKeyDown(event) {
      var open = this.$data._open;
      var disabled = this.$props.disabled;

      if (disabled) {
        return;
      }

      var keyCode = event.keyCode;

      if (open && !this.getInputDOMNode()) {
        this.onInputKeydown(event);
      } else if (keyCode === key_code["a" /* default */].ENTER || keyCode === key_code["a" /* default */].DOWN) {
        // vue state是同步更新，onKeyDown在onMenuSelect后会再次调用，单选时不在调用setOpenState
        // https://github.com/vueComponent/ant-design-vue/issues/1142
        if (keyCode === key_code["a" /* default */].ENTER && !isMultipleOrTags(this.$props)) {
          this.maybeFocus(true);
        } else if (!open) {
          this.setOpenState(true);
        }

        event.preventDefault();
      } else if (keyCode === key_code["a" /* default */].SPACE) {
        // Not block space if popup is shown
        if (!open) {
          this.setOpenState(true);
          event.preventDefault();
        }
      }
    },
    onInputKeydown: function onInputKeydown(event) {
      var _this5 = this;

      var _this$$props = this.$props,
          disabled = _this$$props.disabled,
          combobox = _this$$props.combobox,
          defaultActiveFirstOption = _this$$props.defaultActiveFirstOption;

      if (disabled) {
        return;
      }

      var state = this.$data;
      var isRealOpen = this.getRealOpenState(state);
      var keyCode = event.keyCode;

      if (isMultipleOrTags(this.$props) && !event.target.value && keyCode === key_code["a" /* default */].BACKSPACE) {
        event.preventDefault();
        var value = state._value;

        if (value.length) {
          this.removeSelected(value[value.length - 1]);
        }

        return;
      }

      if (keyCode === key_code["a" /* default */].DOWN) {
        if (!state._open) {
          this.openIfHasChildren();
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      } else if (keyCode === key_code["a" /* default */].ENTER && state._open) {
        // Aviod trigger form submit when select item
        // https://github.com/ant-design/ant-design/issues/10861
        // https://github.com/ant-design/ant-design/issues/14544
        if (isRealOpen || !combobox) {
          event.preventDefault();
        } // Hard close popup to avoid lock of non option in combobox mode


        if (isRealOpen && combobox && defaultActiveFirstOption === false) {
          this.comboboxTimer = setTimeout(function () {
            _this5.setOpenState(false);
          });
        }
      } else if (keyCode === key_code["a" /* default */].ESC) {
        if (state._open) {
          this.setOpenState(false);
          event.preventDefault();
          event.stopPropagation();
        }

        return;
      }

      if (isRealOpen && this.selectTriggerRef) {
        var menu = this.selectTriggerRef.getInnerMenu();

        if (menu && menu.onKeyDown(event, this.handleBackfill)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
    onMenuSelect: function onMenuSelect(_ref) {
      var item = _ref.item;

      if (!item) {
        return;
      }

      var value = this.$data._value;
      var props = this.$props;
      var selectedValue = getValuePropValue(item);
      var lastValue = value[value.length - 1];
      var skipTrigger = false;

      if (isMultipleOrTags(props)) {
        if (findIndexInValueBySingleValue(value, selectedValue) !== -1) {
          skipTrigger = true;
        } else {
          value = value.concat([selectedValue]);
        }
      } else {
        if (!isCombobox(props) && lastValue !== undefined && lastValue === selectedValue && selectedValue !== this.$data._backfillValue) {
          this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });
          skipTrigger = true;
        } else {
          value = [selectedValue];
          this.setOpenState(false, {
            needFocus: true,
            fireSearch: false
          });
        }
      }

      if (!skipTrigger) {
        this.fireChange(value);
      }

      if (!skipTrigger) {
        this.fireSelect(selectedValue);
        var inputValue = isCombobox(props) ? getPropValue(item, props.optionLabelProp) : '';

        if (props.autoClearSearchValue) {
          this.setInputValue(inputValue, false);
        }
      }
    },
    onMenuDeselect: function onMenuDeselect(_ref2) {
      var item = _ref2.item,
          domEvent = _ref2.domEvent;

      if (domEvent.type === 'keydown' && domEvent.keyCode === key_code["a" /* default */].ENTER) {
        var menuItemDomNode = item.$el; // https://github.com/ant-design/ant-design/issues/20465#issuecomment-569033796

        if (!isHidden(menuItemDomNode)) {
          this.removeSelected(getValuePropValue(item));
        }

        return;
      }

      if (domEvent.type === 'click') {
        this.removeSelected(getValuePropValue(item));
      }

      if (this.autoClearSearchValue) {
        this.setInputValue('');
      }
    },
    onArrowClick: function onArrowClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.clearBlurTime();

      if (!this.disabled) {
        this.setOpenState(!this.$data._open, {
          needFocus: !this.$data._open
        });
      }
    },
    onPlaceholderClick: function onPlaceholderClick() {
      if (this.getInputDOMNode() && this.getInputDOMNode()) {
        this.getInputDOMNode().focus();
      }
    },
    onPopupFocus: function onPopupFocus() {
      // fix ie scrollbar, focus element again
      this.maybeFocus(true, true);
    },
    onClearSelection: function onClearSelection(event) {
      var props = this.$props;
      var state = this.$data;

      if (props.disabled) {
        return;
      }

      var inputValue = state._inputValue,
          value = state._value;
      event.stopPropagation();

      if (inputValue || value.length) {
        if (value.length) {
          this.fireChange([]);
        }

        this.setOpenState(false, {
          needFocus: true
        });

        if (inputValue) {
          this.setInputValue('');
        }
      }
    },
    onChoiceAnimationLeave: function onChoiceAnimationLeave() {
      this.forcePopupAlign();
    },
    getOptionInfoBySingleValue: function getOptionInfoBySingleValue(value, optionsInfo) {
      var h = this.$createElement;
      var info;
      optionsInfo = optionsInfo || this.$data._optionsInfo;

      if (optionsInfo[getMapKey(value)]) {
        info = optionsInfo[getMapKey(value)];
      }

      if (info) {
        return info;
      }

      var defaultLabel = value;

      if (this.$props.labelInValue) {
        var valueLabel = getLabelFromPropsValue(this.$props.value, value);
        var defaultValueLabel = getLabelFromPropsValue(this.$props.defaultValue, value);

        if (valueLabel !== undefined) {
          defaultLabel = valueLabel;
        } else if (defaultValueLabel !== undefined) {
          defaultLabel = defaultValueLabel;
        }
      }

      var defaultInfo = {
        option: h(Option, {
          attrs: {
            value: value
          },
          key: value
        }, [value]),
        value: value,
        label: defaultLabel
      };
      return defaultInfo;
    },
    getOptionBySingleValue: function getOptionBySingleValue(value) {
      var _this$getOptionInfoBy = this.getOptionInfoBySingleValue(value),
          option = _this$getOptionInfoBy.option;

      return option;
    },
    getOptionsBySingleValue: function getOptionsBySingleValue(values) {
      var _this6 = this;

      return values.map(function (value) {
        return _this6.getOptionBySingleValue(value);
      });
    },
    getValueByLabel: function getValueByLabel(label) {
      var _this7 = this;

      if (label === undefined) {
        return null;
      }

      var value = null;
      Object.keys(this.$data._optionsInfo).forEach(function (key) {
        var info = _this7.$data._optionsInfo[key];
        var disabled = info.disabled;

        if (disabled) {
          return;
        }

        var oldLable = toArray(info.label);

        if (oldLable && oldLable.join('') === label) {
          value = info.value;
        }
      });
      return value;
    },
    getVLBySingleValue: function getVLBySingleValue(value) {
      if (this.$props.labelInValue) {
        return {
          key: value,
          label: this.getLabelBySingleValue(value)
        };
      }

      return value;
    },
    getVLForOnChange: function getVLForOnChange(vlsS) {
      var _this8 = this;

      var vls = vlsS;

      if (vls !== undefined) {
        if (!this.labelInValue) {
          vls = vls.map(function (v) {
            return v;
          });
        } else {
          vls = vls.map(function (vl) {
            return {
              key: vl,
              label: _this8.getLabelBySingleValue(vl)
            };
          });
        }

        return isMultipleOrTags(this.$props) ? vls : vls[0];
      }

      return vls;
    },
    getLabelBySingleValue: function getLabelBySingleValue(value, optionsInfo) {
      var _this$getOptionInfoBy2 = this.getOptionInfoBySingleValue(value, optionsInfo),
          label = _this$getOptionInfoBy2.label;

      return label;
    },
    getDropdownContainer: function getDropdownContainer() {
      if (!this.dropdownContainer) {
        this.dropdownContainer = document.createElement('div');
        document.body.appendChild(this.dropdownContainer);
      }

      return this.dropdownContainer;
    },
    getPlaceholderElement: function getPlaceholderElement() {
      var h = this.$createElement;
      var props = this.$props,
          state = this.$data;
      var hidden = false;

      if (state._mirrorInputValue) {
        hidden = true;
      }

      var value = state._value;

      if (value.length) {
        hidden = true;
      }

      if (!state._mirrorInputValue && isCombobox(props) && value.length === 1 && state._value && !state._value[0]) {
        hidden = false;
      }

      var placeholder = props.placeholder;

      if (placeholder) {
        var p = {
          on: {
            mousedown: preventDefaultEvent,
            click: this.onPlaceholderClick
          },
          attrs: UNSELECTABLE_ATTRIBUTE,
          style: Select_objectSpread({
            display: hidden ? 'none' : 'block'
          }, UNSELECTABLE_STYLE),
          class: "".concat(props.prefixCls, "-selection__placeholder")
        };
        return h("div", p, [placeholder]);
      }

      return null;
    },
    inputClick: function inputClick(e) {
      if (this.$data._open) {
        this.clearBlurTime();
        e.stopPropagation();
      } else {
        this._focused = false;
      }
    },
    inputBlur: function inputBlur(e) {
      var _this9 = this;

      var target = e.relatedTarget || document.activeElement; // https://github.com/vueComponent/ant-design-vue/issues/999
      // https://github.com/vueComponent/ant-design-vue/issues/1223

      if ((isIE || isEdge) && (e.relatedTarget === this.$refs.arrow || target && this.selectTriggerRef && this.selectTriggerRef.getInnerMenu() && this.selectTriggerRef.getInnerMenu().$el === target || Object(contains["a" /* default */])(e.target, target))) {
        e.target.focus();
        e.preventDefault();
        return;
      }

      this.clearBlurTime();

      if (this.disabled) {
        e.preventDefault();
        return;
      }

      this.blurTimer = setTimeout(function () {
        _this9._focused = false;

        _this9.updateFocusClassName();

        var props = _this9.$props;
        var value = _this9.$data._value;
        var inputValue = _this9.$data._inputValue;

        if (isSingleMode(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
          var options = _this9._options || [];

          if (options.length) {
            var firstOption = findFirstMenuItem(options);

            if (firstOption) {
              value = [getValuePropValue(firstOption)];

              _this9.fireChange(value);
            }
          }
        } else if (isMultipleOrTags(props) && inputValue) {
          if (_this9._mouseDown) {
            // need update dropmenu when not blur
            _this9.setInputValue('');
          } else {
            // why not use setState?
            _this9.$data._inputValue = '';

            if (_this9.getInputDOMNode && _this9.getInputDOMNode()) {
              _this9.getInputDOMNode().value = '';
            }
          }

          var tmpValue = _this9.getValueByInput(inputValue);

          if (tmpValue !== undefined) {
            value = tmpValue;

            _this9.fireChange(value);
          }
        } // if click the rest space of Select in multiple mode


        if (isMultipleOrTags(props) && _this9._mouseDown) {
          _this9.maybeFocus(true, true);

          _this9._mouseDown = false;
          return;
        }

        _this9.setOpenState(false);

        _this9.$emit('blur', _this9.getVLForOnChange(value));
      }, 200);
    },
    inputFocus: function inputFocus(e) {
      if (this.$props.disabled) {
        e.preventDefault();
        return;
      }

      this.clearBlurTime(); // In IE11, onOuterFocus will be trigger twice when focus input
      // First one: e.target is div
      // Second one: e.target is input
      // other browser only trigger second one
      // https://github.com/ant-design/ant-design/issues/15942
      // Here we ignore the first one when e.target is div

      var inputNode = this.getInputDOMNode();

      if (inputNode && e.target === this.rootRef) {
        return;
      }

      if (!isMultipleOrTagsOrCombobox(this.$props) && e.target === inputNode) {
        return;
      }

      if (this._focused) {
        return;
      }

      this._focused = true;
      this.updateFocusClassName(); // only effect multiple or tag mode

      if (!isMultipleOrTags(this.$props) || !this._mouseDown) {
        this.timeoutFocus();
      }
    },
    _getInputElement: function _getInputElement() {
      var h = this.$createElement;
      var props = this.$props;
      var _this$$data = this.$data,
          inputValue = _this$$data._inputValue,
          _mirrorInputValue = _this$$data._mirrorInputValue;
      var attrs = Object(props_util["getAttrs"])(this);
      var defaultInput = h("input", {
        attrs: {
          id: attrs.id,
          autoComplete: "off"
        }
      });
      var inputElement = props.getInputElement ? props.getInputElement() : defaultInput;
      var inputCls = external_classnames_default()(Object(props_util["getClass"])(inputElement), Select_defineProperty({}, "".concat(props.prefixCls, "-search__field"), true));
      var inputEvents = Object(props_util["getEvents"])(inputElement); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
      // Add space to the end of the inputValue as the width measurement tolerance

      inputElement.data = inputElement.data || {};
      return h("div", {
        "class": "".concat(props.prefixCls, "-search__field__wrap"),
        on: {
          "click": this.inputClick
        }
      }, [Object(vnode["a" /* cloneElement */])(inputElement, {
        props: {
          disabled: props.disabled,
          value: inputValue
        },
        attrs: Select_objectSpread(Select_objectSpread({}, inputElement.data.attrs || {}), {}, {
          disabled: props.disabled,
          value: inputValue
        }),
        domProps: {
          value: inputValue
        },
        class: inputCls,
        directives: [{
          name: 'meg-ref',
          value: this.saveInputRef
        }, {
          name: 'meg-input'
        }],
        on: {
          input: chaining(this.onInputChange, inputEvents.input),
          keydown: chaining(this.onInputKeydown, inputEvents.keydown, Object(props_util["getListeners"])(this).inputKeydown),
          focus: chaining(this.inputFocus, inputEvents.focus),
          blur: chaining(this.inputBlur, inputEvents.blur)
        }
      }), h("span", babel_helper_vue_jsx_merge_props_default()([{
        directives: [{
          name: 'meg-ref',
          value: this.saveInputMirrorRef
        }]
      }, {
        // ref='inputMirrorRef'
        "class": "".concat(props.prefixCls, "-search__field__mirror")
      }]), [_mirrorInputValue, "\xA0"])]);
    },
    getInputDOMNode: function getInputDOMNode() {
      return this.topCtrlRef ? this.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : this.inputRef;
    },
    getInputMirrorDOMNode: function getInputMirrorDOMNode() {
      return this.inputMirrorRef;
    },
    getPopupDOMNode: function getPopupDOMNode() {
      if (this.selectTriggerRef) {
        return this.selectTriggerRef.getPopupDOMNode();
      }
    },
    getPopupMenuComponent: function getPopupMenuComponent() {
      if (this.selectTriggerRef) {
        return this.selectTriggerRef.getInnerMenu();
      }
    },
    setOpenState: function setOpenState(open) {
      var _this10 = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = this.$props,
          state = this.$data;
      var needFocus = config.needFocus,
          fireSearch = config.fireSearch;

      if (state._open === open) {
        this.maybeFocus(open, !!needFocus);
        return;
      }

      this.__emit('dropdownVisibleChange', open);

      var nextState = {
        _open: open,
        _backfillValue: ''
      }; // clear search input value when open is false in singleMode.

      if (!open && isSingleMode(props) && props.showSearch) {
        this.setInputValue('', fireSearch);
      }

      if (!open) {
        this.maybeFocus(open, !!needFocus);
      }

      this.setState(nextState, function () {
        if (open) {
          _this10.maybeFocus(open, !!needFocus);
        }
      });
    },
    setInputValue: function setInputValue(inputValue) {
      var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (inputValue !== this.$data._inputValue) {
        this.setState({
          _inputValue: inputValue
        }, this.forcePopupAlign);

        if (fireSearch) {
          this.$emit('search', inputValue);
        }
      }
    },
    getValueByInput: function getValueByInput(str) {
      var _this11 = this;

      var _this$$props2 = this.$props,
          multiple = _this$$props2.multiple,
          tokenSeparators = _this$$props2.tokenSeparators;
      var nextValue = this.$data._value;
      var hasNewValue = false;
      splitBySeparators(str, tokenSeparators).forEach(function (label) {
        var selectedValue = [label];

        if (multiple) {
          var value = _this11.getValueByLabel(label);

          if (value && findIndexInValueBySingleValue(nextValue, value) === -1) {
            nextValue = nextValue.concat(value);
            hasNewValue = true;

            _this11.fireSelect(value);
          }
        } else if (findIndexInValueBySingleValue(nextValue, label) === -1) {
          nextValue = nextValue.concat(selectedValue);
          hasNewValue = true;

          _this11.fireSelect(label);
        }
      });
      return hasNewValue ? nextValue : undefined;
    },
    getRealOpenState: function getRealOpenState(state) {
      var _open = this.$props.open;

      if (typeof _open === 'boolean') {
        return _open;
      }

      var open = (state || this.$data)._open;
      var options = this._options || [];

      if (isMultipleOrTagsOrCombobox(this.$props) || !this.$props.showSearch) {
        if (open && !options.length) {
          open = false;
        }
      }

      return open;
    },
    focus: function focus() {
      if (isSingleMode(this.$props) && this.selectionRef) {
        this.selectionRef.focus();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().focus();
      }
    },
    blur: function blur() {
      if (isSingleMode(this.$props) && this.selectionRef) {
        this.selectionRef.blur();
      } else if (this.getInputDOMNode()) {
        this.getInputDOMNode().blur();
      }
    },
    markMouseDown: function markMouseDown() {
      this._mouseDown = true;
    },
    markMouseLeave: function markMouseLeave() {
      this._mouseDown = false;
    },
    handleBackfill: function handleBackfill(item) {
      if (!this.backfill || !(isSingleMode(this.$props) || isCombobox(this.$props))) {
        return;
      }

      var key = getValuePropValue(item);

      if (isCombobox(this.$props)) {
        this.setInputValue(key, false);
      }

      this.setState({
        _value: [key],
        _backfillValue: key
      });
    },
    _filterOption: function _filterOption(input, child) {
      var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFilterFn;
      var _this$$data2 = this.$data,
          value = _this$$data2._value,
          backfillValue = _this$$data2._backfillValue;
      var lastValue = value[value.length - 1];

      if (!input || lastValue && lastValue === backfillValue) {
        return true;
      }

      var filterFn = this.$props.filterOption;

      if (Object(props_util["hasProp"])(this, 'filterOption')) {
        if (filterFn === true) {
          filterFn = defaultFilter.bind(this);
        }
      } else {
        filterFn = defaultFilter.bind(this);
      }

      if (!filterFn) {
        return true;
      } else if (typeof filterFn === 'function') {
        return filterFn.call(this, input, child);
      } else if (Object(props_util["getValueByProp"])(child, 'disabled')) {
        return false;
      }

      return true;
    },
    timeoutFocus: function timeoutFocus() {
      var _this12 = this;

      if (this.focusTimer) {
        this.clearFocusTime();
      }

      this.focusTimer = window.setTimeout(function () {
        // this._focused = true
        // this.updateFocusClassName()
        _this12.$emit('focus');
      }, 10);
    },
    clearFocusTime: function clearFocusTime() {
      if (this.focusTimer) {
        clearTimeout(this.focusTimer);
        this.focusTimer = null;
      }
    },
    clearBlurTime: function clearBlurTime() {
      if (this.blurTimer) {
        clearTimeout(this.blurTimer);
        this.blurTimer = null;
      }
    },
    clearComboboxTime: function clearComboboxTime() {
      if (this.comboboxTimer) {
        clearTimeout(this.comboboxTimer);
        this.comboboxTimer = null;
      }
    },
    updateFocusClassName: function updateFocusClassName() {
      var rootRef = this.rootRef,
          prefixCls = this.prefixCls; // avoid setState and its side effect

      if (this._focused) {
        component_classes_default()(rootRef).add("".concat(prefixCls, "-focused"));
      } else {
        component_classes_default()(rootRef).remove("".concat(prefixCls, "-focused"));
      }
    },
    maybeFocus: function maybeFocus(open, needFocus) {
      if (needFocus || open) {
        var input = this.getInputDOMNode();
        var _document = document,
            activeElement = _document.activeElement;

        if (input && (open || isMultipleOrTagsOrCombobox(this.$props))) {
          if (activeElement !== input) {
            input.focus();
            this._focused = true;
          }
        } else if (activeElement !== this.selectionRef && this.selectionRef) {
          this.selectionRef.focus();
          this._focused = true;
        }
      }
    },
    removeSelected: function removeSelected(selectedKey, e) {
      var props = this.$props;

      if (props.disabled || this.isChildDisabled(selectedKey)) {
        return;
      } // Do not trigger Trigger popup


      if (e && e.stopPropagation) {
        e.stopPropagation();
      }

      var oldValue = this.$data._value;
      var value = oldValue.filter(function (singleValue) {
        return singleValue !== selectedKey;
      });
      var canMultiple = isMultipleOrTags(props);

      if (canMultiple) {
        var event = selectedKey;

        if (props.labelInValue) {
          event = {
            key: selectedKey,
            label: this.getLabelBySingleValue(selectedKey)
          };
        }

        this.$emit('deselect', event, this.getOptionBySingleValue(selectedKey));
      }

      this.fireChange(value);
    },
    openIfHasChildren: function openIfHasChildren() {
      var $props = this.$props;

      if ($props.children && $props.children.length || isSingleMode($props)) {
        this.setOpenState(true);
      }
    },
    fireSelect: function fireSelect(value) {
      this.$emit('select', this.getVLBySingleValue(value), this.getOptionBySingleValue(value));
    },
    fireChange: function fireChange(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          _value: value
        }, this.forcePopupAlign);
      }

      var vls = this.getVLForOnChange(value);
      var options = this.getOptionsBySingleValue(value);
      this._valueOptions = options;
      this.$emit('change', vls, isMultipleOrTags(this.$props) ? options : options[0]);
    },
    isChildDisabled: function isChildDisabled(key) {
      return (this.$props.children || []).some(function (child) {
        var childValue = getValuePropValue(child);
        return childValue === key && Object(props_util["getValueByProp"])(child, 'disabled');
      });
    },
    forcePopupAlign: function forcePopupAlign() {
      if (!this.$data._open) {
        return;
      }

      if (this.selectTriggerRef && this.selectTriggerRef.triggerRef) {
        this.selectTriggerRef.triggerRef.forcePopupAlign();
      }
    },
    renderFilterOptions: function renderFilterOptions() {
      var h = this.$createElement;
      var inputValue = this.$data._inputValue;
      var _this$$props3 = this.$props,
          children = _this$$props3.children,
          tags = _this$$props3.tags,
          notFoundContent = _this$$props3.notFoundContent;
      var menuItems = [];
      var childrenKeys = [];
      var empty = false;
      var options = this.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);

      if (tags) {
        // tags value must be string
        var value = this.$data._value;
        value = value.filter(function (singleValue) {
          return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
        }); // sort by length

        value.sort(function (val1, val2) {
          return val1.length - val2.length;
        });
        value.forEach(function (singleValue) {
          var key = singleValue;

          var attrs = Select_objectSpread(Select_objectSpread({}, UNSELECTABLE_ATTRIBUTE), {}, {
            role: 'option'
          });

          var menuItem = h(vc_menu["b" /* Item */], babel_helper_vue_jsx_merge_props_default()([{
            style: UNSELECTABLE_STYLE
          }, {
            attrs: attrs
          }, {
            attrs: {
              value: key
            },
            key: key
          }]), [key]);
          options.push(menuItem);
          menuItems.push(menuItem);
        }); // ref: https://github.com/ant-design/ant-design/issues/14090

        if (inputValue && menuItems.every(function (option) {
          return getValuePropValue(option) !== inputValue;
        })) {
          var p = {
            attrs: UNSELECTABLE_ATTRIBUTE,
            key: inputValue,
            props: {
              value: inputValue,
              role: 'option'
            },
            style: UNSELECTABLE_STYLE
          };
          options.unshift(h(vc_menu["b" /* Item */], p, [inputValue]));
        }
      }

      if (!options.length && notFoundContent) {
        empty = true;
        var _p = {
          attrs: UNSELECTABLE_ATTRIBUTE,
          key: 'NOT_FOUND',
          props: {
            value: 'NOT_FOUND',
            disabled: true,
            role: 'option'
          },
          style: UNSELECTABLE_STYLE
        };
        options = [h(vc_menu["b" /* Item */], _p, [notFoundContent])];
      }

      return {
        empty: empty,
        options: options
      };
    },
    renderFilterOptionsFromChildren: function renderFilterOptionsFromChildren() {
      var _this13 = this;

      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var childrenKeys = arguments.length > 1 ? arguments[1] : undefined;
      var menuItems = arguments.length > 2 ? arguments[2] : undefined;
      var h = this.$createElement;
      var sel = [];
      var props = this.$props;
      var inputValue = this.$data._inputValue;
      var tags = props.tags;
      children.forEach(function (child) {
        if (!child.data || child.data.slot !== undefined) {
          return;
        }

        if (Object(props_util["getSlotOptions"])(child).isSelectOptGroup) {
          var label = Object(props_util["getComponentFromProp"])(child, 'label');
          var key = child.key;

          if (!key && typeof label === 'string') {
            key = label;
          } else if (!label && key) {
            label = key;
          }

          var childChildren = Object(props_util["getSlots"])(child).default;
          childChildren = typeof childChildren === 'function' ? childChildren() : childChildren; // Match option group label

          if (inputValue && _this13._filterOption(inputValue, child)) {
            var innerItems = childChildren.map(function (subChild) {
              var childValueSub = getValuePropValue(subChild) || subChild.key;
              return h(vc_menu["b" /* Item */], babel_helper_vue_jsx_merge_props_default()([{
                key: childValueSub,
                attrs: {
                  value: childValueSub
                }
              }, subChild.data]), [subChild.componentOptions.children]);
            });
            sel.push(h(vc_menu["c" /* ItemGroup */], {
              key: key,
              attrs: {
                title: label
              },
              "class": Object(props_util["getClass"])(child)
            }, [innerItems])); // Not match
          } else {
            var _innerItems = _this13.renderFilterOptionsFromChildren(childChildren, childrenKeys, menuItems);

            if (_innerItems.length) {
              sel.push(h(vc_menu["c" /* ItemGroup */], babel_helper_vue_jsx_merge_props_default()([{
                key: key,
                attrs: {
                  title: label
                }
              }, child.data]), [_innerItems]));
            }
          }

          return;
        }

        warning_default()(Object(props_util["getSlotOptions"])(child).isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + "instead of `".concat(Object(props_util["getSlotOptions"])(child).name || Object(props_util["getSlotOptions"])(child), "`."));
        var childValue = getValuePropValue(child);
        validateOptionValue(childValue, _this13.$props);

        if (_this13._filterOption(inputValue, child)) {
          var p = {
            attrs: Select_objectSpread(Select_objectSpread({}, UNSELECTABLE_ATTRIBUTE), Object(props_util["getAttrs"])(child)),
            key: childValue,
            props: Select_objectSpread(Select_objectSpread({
              value: childValue
            }, Object(props_util["getPropsData"])(child)), {}, {
              role: 'option'
            }),
            style: UNSELECTABLE_STYLE,
            on: Object(props_util["getEvents"])(child),
            class: Object(props_util["getClass"])(child)
          };
          var menuItem = h(vc_menu["b" /* Item */], p, [child.componentOptions.children]);
          sel.push(menuItem);
          menuItems.push(menuItem);
        }

        if (tags) {
          childrenKeys.push(childValue);
        }
      });
      return sel;
    },
    renderTopControlNode: function renderTopControlNode() {
      var _this14 = this;

      var h = this.$createElement;
      var props = this.$props;
      var _this$$data3 = this.$data,
          value = _this$$data3._value,
          inputValue = _this$$data3._inputValue,
          open = _this$$data3._open;
      var choiceTransitionName = props.choiceTransitionName,
          prefixCls = props.prefixCls,
          maxTagTextLength = props.maxTagTextLength,
          maxTagCount = props.maxTagCount,
          maxTagPlaceholder = props.maxTagPlaceholder,
          showSearch = props.showSearch;
      var removeIcon = Object(props_util["getComponentFromProp"])(this, 'removeIcon');
      var className = "".concat(prefixCls, "-selection__rendered"); // search input is inside topControlNode in single, multiple & combobox. 2016/04/13

      var innerNode = null;

      if (isSingleMode(props)) {
        var selectedValue = null;

        if (value.length) {
          var showSelectedValue = false;
          var opacity = 1;

          if (!showSearch) {
            showSelectedValue = true;
          } else if (open) {
            showSelectedValue = !inputValue;

            if (showSelectedValue) {
              opacity = 0.4;
            }
          } else {
            showSelectedValue = true;
          }

          var singleValue = value[0];

          var _this$getOptionInfoBy3 = this.getOptionInfoBySingleValue(singleValue),
              label = _this$getOptionInfoBy3.label,
              title = _this$getOptionInfoBy3.title;

          selectedValue = h("div", {
            key: "value",
            "class": "".concat(prefixCls, "-selection-selected-value"),
            attrs: {
              title: toTitle(title || label)
            },
            style: {
              display: showSelectedValue ? 'block' : 'none',
              opacity: opacity
            }
          }, [label]);
        }

        if (!showSearch) {
          innerNode = [selectedValue];
        } else {
          innerNode = [selectedValue, h("div", {
            "class": "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
            key: "input",
            style: {
              display: open ? 'block' : 'none'
            }
          }, [this._getInputElement()])];
        }
      } else {
        var selectedValueNodes = [];
        var limitedCountValue = value;
        var maxTagPlaceholderEl;

        if (maxTagCount !== undefined && value.length > maxTagCount) {
          limitedCountValue = limitedCountValue.slice(0, maxTagCount);
          var omittedValues = this.getVLForOnChange(value.slice(maxTagCount, value.length));
          var content = "+ ".concat(value.length - maxTagCount);

          if (maxTagPlaceholder) {
            content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
          }

          var attrs = Select_objectSpread(Select_objectSpread({}, UNSELECTABLE_ATTRIBUTE), {}, {
            role: 'presentation',
            title: toTitle(content)
          });

          maxTagPlaceholderEl = h("li", babel_helper_vue_jsx_merge_props_default()([{
            style: UNSELECTABLE_STYLE
          }, {
            attrs: attrs
          }, {
            on: {
              "mousedown": preventDefaultEvent
            },
            "class": "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled"),
            key: "maxTagPlaceholder"
          }]), [h("div", {
            "class": "".concat(prefixCls, "-selection__choice__content")
          }, [content])]);
        }

        if (isMultipleOrTags(props)) {
          selectedValueNodes = limitedCountValue.map(function (singleValue) {
            var info = _this14.getOptionInfoBySingleValue(singleValue);

            var content = info.label;
            var title = info.title || content;

            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
              content = "".concat(content.slice(0, maxTagTextLength), "...");
            }

            var disabled = _this14.isChildDisabled(singleValue);

            var choiceClassName = disabled ? "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled") : "".concat(prefixCls, "-selection__choice"); // attrs 放在一起，避免动态title混乱问题，很奇怪的问题 https://github.com/vueComponent/ant-design-vue/issues/588

            var attrs = Select_objectSpread(Select_objectSpread({}, UNSELECTABLE_ATTRIBUTE), {}, {
              role: 'presentation',
              title: toTitle(title)
            });

            return h("li", babel_helper_vue_jsx_merge_props_default()([{
              style: UNSELECTABLE_STYLE
            }, {
              attrs: attrs
            }, {
              on: {
                "mousedown": preventDefaultEvent
              },
              "class": choiceClassName,
              key: singleValue || SELECT_EMPTY_VALUE_KEY
            }]), [h("div", {
              "class": "".concat(prefixCls, "-selection__choice__content")
            }, [content]), disabled ? null : h("span", {
              on: {
                "click": function click(event) {
                  _this14.removeSelected(singleValue, event);
                }
              },
              "class": "".concat(prefixCls, "-selection__choice__remove")
            }, [removeIcon || h("i", {
              "class": "".concat(prefixCls, "-selection__choice__remove-icon")
            }, ["\xD7"])])]);
          });
        }

        if (maxTagPlaceholderEl) {
          selectedValueNodes.push(maxTagPlaceholderEl);
        }

        selectedValueNodes.push(h("li", {
          "class": "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
          key: "__input"
        }, [this._getInputElement()])); // 动画transition效果不生效,暂时去掉
        // if (isMultipleOrTags(props) && choiceTransitionName) {
        //     const transitionProps = getTransitionProps(choiceTransitionName, {
        //         tag: 'ul',
        //         afterLeave: this.onChoiceAnimationLeave,
        //     });
        //     innerNode = (
        //         <transition-group {...transitionProps}>{selectedValueNodes}</transition-group>
        //     );
        // } else {
        //     innerNode = <ul>{selectedValueNodes}</ul>;
        // }

        innerNode = h("ul", [selectedValueNodes]);
      }

      return h("div", babel_helper_vue_jsx_merge_props_default()([{
        "class": className
      }, {
        directives: [{
          name: 'meg-ref',
          value: this.saveTopCtrlRef
        }]
      }, {
        on: {
          "click": this.topCtrlContainerClick
        }
      }]), [this.getPlaceholderElement(), innerNode]);
    },
    renderArrow: function renderArrow(multiple) {
      var h = this.$createElement;
      // showArrow : Set to true if not multiple by default but keep set value.
      var _this$$props4 = this.$props,
          _this$$props4$showArr = _this$$props4.showArrow,
          showArrow = _this$$props4$showArr === void 0 ? !multiple : _this$$props4$showArr,
          loading = _this$$props4.loading,
          prefixCls = _this$$props4.prefixCls;
      var inputIcon = Object(props_util["getComponentFromProp"])(this, 'inputIcon');

      if (!showArrow && !loading) {
        return null;
      } // if loading  have loading icon


      var defaultIcon = loading ? h("i", {
        "class": "".concat(prefixCls, "-arrow-loading")
      }) : h("i", {
        "class": "".concat(prefixCls, "-arrow-icon")
      });
      return h("span", babel_helper_vue_jsx_merge_props_default()([{
        key: "arrow",
        "class": "".concat(prefixCls, "-arrow"),
        style: UNSELECTABLE_STYLE
      }, {
        attrs: UNSELECTABLE_ATTRIBUTE
      }, {
        on: {
          "click": this.onArrowClick
        },
        ref: "arrow"
      }]), [inputIcon || defaultIcon]);
    },
    topCtrlContainerClick: function topCtrlContainerClick(e) {
      if (this.$data._open && !isSingleMode(this.$props)) {
        e.stopPropagation();
      }
    },
    renderClear: function renderClear() {
      var h = this.$createElement;
      var _this$$props5 = this.$props,
          prefixCls = _this$$props5.prefixCls,
          allowClear = _this$$props5.allowClear;
      var _this$$data4 = this.$data,
          value = _this$$data4._value,
          inputValue = _this$$data4._inputValue;
      var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
      var clear = h("span", babel_helper_vue_jsx_merge_props_default()([{
        key: "clear",
        "class": "".concat(prefixCls, "-selection__clear"),
        on: {
          "mousedown": preventDefaultEvent
        },
        style: UNSELECTABLE_STYLE
      }, {
        attrs: UNSELECTABLE_ATTRIBUTE
      }, {
        on: {
          "click": this.onClearSelection
        }
      }]), [clearIcon || h("i", {
        "class": "".concat(prefixCls, "-selection__clear-icon")
      }, ["\xD7"])]);

      if (!allowClear) {
        return null;
      }

      if (isCombobox(this.$props)) {
        if (inputValue) {
          return clear;
        }

        return null;
      }

      if (inputValue || value.length) {
        return clear;
      }

      return null;
    },
    selectionRefClick: function selectionRefClick() {
      //e.stopPropagation();
      if (!this.disabled) {
        var input = this.getInputDOMNode();

        if (this._focused && this.$data._open) {
          // this._focused = false;
          this.setOpenState(false, false);
          input && input.blur();
        } else {
          this.clearBlurTime(); //this._focused = true;

          this.setOpenState(true, true);
          input && input.focus();
        }
      }
    },
    selectionRefFocus: function selectionRefFocus(e) {
      if (this._focused || this.disabled || isMultipleOrTagsOrCombobox(this.$props)) {
        e.preventDefault();
        return;
      }

      this._focused = true;
      this.updateFocusClassName();
      this.$emit('focus');
    },
    selectionRefBlur: function selectionRefBlur(e) {
      if (isMultipleOrTagsOrCombobox(this.$props)) {
        e.preventDefault();
        return;
      }

      this.inputBlur(e);
    }
  },
  render: function render() {
    var _rootCls;

    var h = arguments[0];
    var props = this.$props;
    var multiple = isMultipleOrTags(props); // Default set showArrow to true if not set (not set directly in defaultProps to handle multiple case)

    var _props$showArrow = props.showArrow,
        showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
    var state = this.$data;
    var disabled = props.disabled,
        prefixCls = props.prefixCls,
        loading = props.loading;
    var ctrlNode = this.renderTopControlNode();
    var _this$$data5 = this.$data,
        open = _this$$data5._open,
        inputValue = _this$$data5._inputValue,
        value = _this$$data5._value;

    if (open) {
      var filterOptions = this.renderFilterOptions();
      this._empty = filterOptions.empty;
      this._options = filterOptions.options;
    }

    var realOpen = this.getRealOpenState();
    var empty = this._empty;
    var options = this._options || [];

    var _getListeners = Object(props_util["getListeners"])(this),
        _getListeners$mouseen = _getListeners.mouseenter,
        mouseenter = _getListeners$mouseen === void 0 ? noop : _getListeners$mouseen,
        _getListeners$mousele = _getListeners.mouseleave,
        mouseleave = _getListeners$mousele === void 0 ? noop : _getListeners$mousele,
        _getListeners$popupSc = _getListeners.popupScroll,
        popupScroll = _getListeners$popupSc === void 0 ? noop : _getListeners$popupSc;

    var selectionProps = {
      props: {},
      attrs: {
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-haspopup': 'true',
        'aria-expanded': realOpen,
        'aria-controls': this.$data._ariaId
      },
      on: {// click: this.selectionRefClick,
      },
      class: "".concat(prefixCls, "-selection ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single'),
      // directives: [
      //   {
      //     name: 'meg-ref',
      //     value: this.saveSelectionRef,
      //   },
      // ],
      key: 'selection'
    }; //if (!isMultipleOrTagsOrCombobox(props)) {
    // selectionProps.on.keydown = this.onKeyDown;
    // selectionProps.on.focus = this.selectionRefFocus;
    // selectionProps.on.blur = this.selectionRefBlur;
    // selectionProps.attrs.tabIndex = props.disabled ? -1 : props.tabIndex;
    //}

    var rootCls = (_rootCls = {}, Select_defineProperty(_rootCls, prefixCls, true), Select_defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), Select_defineProperty(_rootCls, "".concat(prefixCls, "-focused"), open || !!this._focused), Select_defineProperty(_rootCls, "".concat(prefixCls, "-combobox"), isCombobox(props)), Select_defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), Select_defineProperty(_rootCls, "".concat(prefixCls, "-enabled"), !disabled), Select_defineProperty(_rootCls, "".concat(prefixCls, "-allow-clear"), !!props.allowClear), Select_defineProperty(_rootCls, "".concat(prefixCls, "-no-arrow"), !showArrow), Select_defineProperty(_rootCls, "".concat(prefixCls, "-loading"), !!loading), Select_defineProperty(_rootCls, "".concat(prefixCls, "-dark"), props.dark), _rootCls);
    return h(SelectTrigger, babel_helper_vue_jsx_merge_props_default()([{
      attrs: {
        dropdownAlign: props.dropdownAlign,
        dropdownClassName: props.dropdownClassName,
        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
        defaultActiveFirstOption: props.defaultActiveFirstOption,
        dropdownMenuStyle: props.dropdownMenuStyle,
        transitionName: props.transitionName,
        animation: props.animation,
        prefixCls: props.prefixCls,
        dropdownStyle: props.dropdownStyle,
        combobox: props.combobox,
        showSearch: props.showSearch,
        options: options,
        empty: empty,
        multiple: multiple,
        disabled: disabled,
        visible: realOpen,
        inputValue: inputValue,
        value: value,
        backfillValue: state._backfillValue,
        firstActiveValue: props.firstActiveValue,
        getPopupContainer: props.getPopupContainer,
        showAction: props.showAction,
        menuItemSelectedIcon: Object(props_util["getComponentFromProp"])(this, 'menuItemSelectedIcon')
      },
      on: {
        "dropdownVisibleChange": this.onDropdownVisibleChange,
        "menuSelect": this.onMenuSelect,
        "menuDeselect": this.onMenuDeselect,
        "popupScroll": popupScroll,
        "popupFocus": this.onPopupFocus,
        "mouseenter": mouseenter,
        "mouseleave": mouseleave
      }
    }, {
      directives: [{
        name: 'meg-ref',
        value: this.saveSelectTriggerRef
      }]
    }, {
      attrs: {
        dropdownRender: props.dropdownRender,
        ariaId: this.$data._ariaId,
        dark: props.dark
      }
    }]), [h("div", babel_helper_vue_jsx_merge_props_default()([{
      directives: [{
        name: 'meg-ref',
        value: chaining(this.saveRootRef, this.saveSelectionRef)
      }]
    }, {
      style: Object(props_util["getStyle"])(this),
      "class": external_classnames_default()(rootCls),
      on: {
        "mousedown": this.markMouseDown,
        "mouseup": this.markMouseLeave,
        "mouseout": this.markMouseLeave,
        "blur": this.selectionRefBlur,
        "focus": this.selectionRefFocus,
        "click": this.selectionRefClick,
        "keydown": isMultipleOrTagsOrCombobox(props) ? noop : this.onKeyDown
      },
      attrs: {
        tabIndex: props.disabled ? -1 : props.tabIndex
      }
    }]), [h("div", selectionProps, [ctrlNode, this.renderClear(), this.renderArrow(!!multiple)])])]);
  }
};

/* harmony default export */ var vc_select_Select = (Object(proxyComponent["a" /* default */])(Select));
// CONCATENATED MODULE: ./src/base/vc-select/index.js
// based on vc-select 9.2.2




Select.Option = Option;
Select.OptGroup = OptGroup;
vc_select_Select.Option = Option;
vc_select_Select.OptGroup = OptGroup;

/* harmony default export */ var vc_select = (vc_select_Select);
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// EXTERNAL MODULE: ./src/directives/index.js + 3 modules
var directives = __webpack_require__(46);

// CONCATENATED MODULE: ./src/components/select/index.jsx

var _excluded = ["prefixCls", "size", "mode", "options", "getPopupContainer", "isInPopUps", "showArrow"],
    _excluded2 = ["key", "label", "on", "class", "style"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { select_ownKeys(Object(source), true).forEach(function (key) { select_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function select_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // import Base from '../base';

 // import './style/index.scss';

var select_AbstractSelectProps = function AbstractSelectProps() {
  return {
    prefixCls: vue_types["a" /* default */].string,
    size: vue_types["a" /* default */].oneOf(['small', 'large', 'default']),
    showAction: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].arrayOf(String)]),
    notFoundContent: vue_types["a" /* default */].any,
    transitionName: vue_types["a" /* default */].string,
    choiceTransitionName: vue_types["a" /* default */].string,
    showSearch: vue_types["a" /* default */].bool,
    allowClear: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    tabIndex: vue_types["a" /* default */].number,
    placeholder: vue_types["a" /* default */].any,
    defaultActiveFirstOption: vue_types["a" /* default */].bool,
    dropdownClassName: vue_types["a" /* default */].string,
    dropdownStyle: vue_types["a" /* default */].any,
    dropdownMenuStyle: vue_types["a" /* default */].any,
    dropdownMatchSelectWidth: vue_types["a" /* default */].bool,
    // onSearch: (value: string) => any,
    filterOption: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].bool, vue_types["a" /* default */].func]),
    autoFocus: vue_types["a" /* default */].bool,
    backfill: vue_types["a" /* default */].bool,
    showArrow: vue_types["a" /* default */].bool,
    getPopupContainer: vue_types["a" /* default */].func,
    open: vue_types["a" /* default */].bool,
    defaultOpen: vue_types["a" /* default */].bool,
    autoClearSearchValue: vue_types["a" /* default */].bool,
    dropdownRender: vue_types["a" /* default */].func,
    loading: vue_types["a" /* default */].bool
  };
};

var Value = vue_types["a" /* default */].shape({
  key: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])
}).loose;
var SelectValue = vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([Value, vue_types["a" /* default */].string, vue_types["a" /* default */].number])), Value]);

var SelectProps = select_objectSpread(select_objectSpread({}, select_AbstractSelectProps()), {}, {
  value: SelectValue,
  defaultValue: SelectValue,
  // mode: PropTypes.oneOf(['default', 'multiple', 'tags', 'combobox']),
  mode: vue_types["a" /* default */].string,
  optionLabelProp: vue_types["a" /* default */].string,
  firstActiveValue: vue_types["a" /* default */].oneOfType([String, vue_types["a" /* default */].arrayOf(String)]),
  maxTagCount: vue_types["a" /* default */].number,
  maxTagPlaceholder: vue_types["a" /* default */].any,
  maxTagTextLength: vue_types["a" /* default */].number,
  dropdownMatchSelectWidth: vue_types["a" /* default */].bool,
  optionFilterProp: vue_types["a" /* default */].string,
  labelInValue: vue_types["a" /* default */].boolean,
  getPopupContainer: vue_types["a" /* default */].func,
  tokenSeparators: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string),
  getInputElement: vue_types["a" /* default */].func,
  options: vue_types["a" /* default */].array,
  suffixIcon: vue_types["a" /* default */].any,
  removeIcon: vue_types["a" /* default */].any,
  clearIcon: vue_types["a" /* default */].any,
  menuItemSelectedIcon: vue_types["a" /* default */].any
});

var select_SelectPropTypes = {
  prefixCls: vue_types["a" /* default */].string,
  size: vue_types["a" /* default */].oneOf(['default', 'large', 'small']),
  // combobox: PropTypes.bool,
  notFoundContent: vue_types["a" /* default */].any,
  showSearch: vue_types["a" /* default */].bool,
  optionLabelProp: vue_types["a" /* default */].string,
  transitionName: vue_types["a" /* default */].string,
  choiceTransitionName: vue_types["a" /* default */].string
};

var SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
var select_Select = {
  SECRET_COMBOBOX_MODE_DO_NOT_USE: SECRET_COMBOBOX_MODE_DO_NOT_USE,
  Option: select_objectSpread(select_objectSpread({}, Option), {}, {
    name: 'MegSelectOption'
  }),
  OptGroup: select_objectSpread(select_objectSpread({}, OptGroup), {}, {
    name: 'MegSelectOptGroup'
  }),
  name: 'MegSelect',
  props: select_objectSpread(select_objectSpread({}, SelectProps), {}, {
    showSearch: vue_types["a" /* default */].bool.def(false),
    transitionName: vue_types["a" /* default */].string.def('slide-up'),
    choiceTransitionName: vue_types["a" /* default */].string.def('zoom'),
    dark: vue_types["a" /* default */].bool.def(false),
    // 支持通过 dark 来控制深色样式
    isInPopUps: vue_types["a" /* default */].bool.def(false)
  }),
  propTypes: select_SelectPropTypes,
  model: {
    prop: 'value',
    event: 'change'
  },
  provide: function provide() {
    return {
      savePopupRef: this.savePopupRef
    };
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  created: function created() {
    Object(warning["a" /* default */])(this.$props.mode !== 'combobox', 'Select', 'The combobox mode of Select is deprecated,' + 'it will be removed in next major version,' + 'please use AutoComplete instead');
  },
  methods: {
    getNotFoundContent: function getNotFoundContent(renderEmpty) {
      var h = this.$createElement;
      var notFoundContent = Object(props_util["getComponentFromProp"])(this, 'notFoundContent');

      if (notFoundContent !== undefined) {
        return notFoundContent;
      }

      if (this.isCombobox()) {
        return null;
      }

      return renderEmpty(h, 'Select');
    },
    savePopupRef: function savePopupRef(ref) {
      this.popupRef = ref;
    },
    focus: function focus() {
      this.$refs.vcSelect.focus();
    },
    blur: function blur() {
      this.$refs.vcSelect.blur();
    },
    input: function input() {
      this.$refs.vcSelect.input();
    },
    isCombobox: function isCombobox() {
      var mode = this.mode;
      return mode === 'combobox' || mode === SECRET_COMBOBOX_MODE_DO_NOT_USE;
    },
    renderSuffixIcon: function renderSuffixIcon(prefixCls) {
      var showSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var h = this.$createElement;
      var loading = this.$props.loading;
      var suffixIcon = Object(props_util["getComponentFromProp"])(this, 'suffixIcon');
      suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;

      if (suffixIcon) {
        return Object(props_util["isValidElement"])(suffixIcon) ? Object(vnode["a" /* cloneElement */])(suffixIcon, {
          class: "".concat(prefixCls, "-arrow-icon")
        }) : suffixIcon;
      }

      if (loading) {
        return h("meg-icon", {
          attrs: {
            original: true,
            name: "megui-loading",
            iconClass: "loading"
          }
        });
      }

      return h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-dropdown"
        },
        "class": "".concat(prefixCls, "-arrow-icon")
      });
    }
  },
  render: function render() {
    var _cls;

    var h = arguments[0];

    var _getOptionProps = Object(props_util["getOptionProps"])(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        size = _getOptionProps.size,
        mode = _getOptionProps.mode,
        options = _getOptionProps.options,
        getPopupContainer = _getOptionProps.getPopupContainer,
        isInPopUps = _getOptionProps.isInPopUps,
        showArrow = _getOptionProps.showArrow,
        restProps = _objectWithoutProperties(_getOptionProps, _excluded);

    var getPrefixCls = this.configProvider.getPrefixCls;
    var renderEmpty = this.configProvider.renderEmpty;
    var prefixCls = getPrefixCls('select', customizePrefixCls);
    var getContextPopupContainer = this.configProvider.getPopupContainer;
    var removeIcon = Object(props_util["getComponentFromProp"])(this, 'removeIcon');
    removeIcon = Array.isArray(removeIcon) ? removeIcon[0] : removeIcon;
    var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
    clearIcon = Array.isArray(clearIcon) ? clearIcon[0] : clearIcon;
    var menuItemSelectedIcon = Object(props_util["getComponentFromProp"])(this, 'menuItemSelectedIcon');
    menuItemSelectedIcon = Array.isArray(menuItemSelectedIcon) ? menuItemSelectedIcon[0] : menuItemSelectedIcon;
    var rest = Object(es["a" /* default */])(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'suffixIcon', 'menuItemSelectedIcon']);
    var cls = (_cls = {}, select_defineProperty(_cls, "".concat(prefixCls, "-lg"), size === 'large'), select_defineProperty(_cls, "".concat(prefixCls, "-sm"), size === 'small'), select_defineProperty(_cls, "".concat(prefixCls, "-show-arrow"), showArrow), _cls);
    var optionLabelProp = this.$props.optionLabelProp;

    if (this.isCombobox()) {
      // children 带 dom 结构时，无法填入输入框
      optionLabelProp = optionLabelProp || 'value';
    }

    var modeConfig = {
      multiple: mode === 'multiple',
      tags: mode === 'tags',
      combobox: this.isCombobox()
    };
    var finalRemoveIcon = removeIcon && (Object(props_util["isValidElement"])(removeIcon) ? Object(vnode["a" /* cloneElement */])(removeIcon, {
      class: "".concat(prefixCls, "-remove-icon")
    }) : removeIcon) || h("meg-icon", {
      attrs: {
        name: "megui-close"
      },
      "class": "meg-select-remove-icon"
    });
    var finalClearIcon = clearIcon && (Object(props_util["isValidElement"])(clearIcon) ? Object(vnode["a" /* cloneElement */])(clearIcon, {
      class: "".concat(prefixCls, "-clear-icon")
    }) : clearIcon) || h("meg-icon", {
      attrs: {
        name: "megui-fill-close-circle",
        original: true,
        color: "rgba(24,23,37,0.3)"
      },
      "class": "".concat(prefixCls, "-clear-icon")
    });
    var finalMenuItemSelectedIcon = menuItemSelectedIcon && (Object(props_util["isValidElement"])(menuItemSelectedIcon) ? Object(vnode["a" /* cloneElement */])(menuItemSelectedIcon, {
      class: "".concat(prefixCls, "-selected-icon")
    }) : menuItemSelectedIcon) || h("meg-icon", {
      attrs: {
        name: "megui-fill-checked"
      },
      "class": "".concat(prefixCls, "-selected-icon")
    });
    var selectProps = {
      props: select_objectSpread(select_objectSpread(select_objectSpread({
        inputIcon: this.renderSuffixIcon(prefixCls, this.showSearch),
        removeIcon: finalRemoveIcon,
        clearIcon: finalClearIcon,
        menuItemSelectedIcon: finalMenuItemSelectedIcon,
        showArrow: showArrow
      }, rest), modeConfig), {}, {
        prefixCls: prefixCls,
        optionLabelProp: optionLabelProp || 'children',
        notFoundContent: this.getNotFoundContent(renderEmpty),
        maxTagPlaceholder: Object(props_util["getComponentFromProp"])(this, 'maxTagPlaceholder'),
        placeholder: Object(props_util["getComponentFromProp"])(this, 'placeholder'),
        children: options ? options.map(function (option) {
          var key = option.key,
              _option$label = option.label,
              label = _option$label === void 0 ? option.title : _option$label,
              on = option.on,
              cls = option.class,
              style = option.style,
              restOption = _objectWithoutProperties(option, _excluded2);

          return h(Option, babel_helper_vue_jsx_merge_props_default()([{
            key: key
          }, {
            props: restOption,
            on: on,
            class: cls,
            style: style
          }]), [label]);
        }) : Object(props_util["filterEmpty"])(this.$slots.default),
        __propsSymbol__: Symbol(),
        dropdownRender: Object(props_util["getComponentFromProp"])(this, 'dropdownRender', {}, false),
        getPopupContainer: !!isInPopUps ? function (triggerNode) {
          return triggerNode.parentNode;
        } : getPopupContainer || getContextPopupContainer
      }),
      on: Object(props_util["getListeners"])(this),
      class: cls,
      ref: 'vcSelect'
    };
    return h(Select, selectProps);
  }
};
/* istanbul ignore next */

select_Select.install = function (Vue) {
  // Vue.use(Base);
  Vue.use(directives["a" /* default */]);
  Vue.component(select_Select.name, select_Select);
  Vue.component(select_Select.Option.name, select_Select.Option);
  Vue.component(select_Select.OptGroup.name, select_Select.OptGroup);
};

/* harmony default export */ var components_select = __webpack_exports__["default"] = (select_Select);

/***/ })

}]);